 import { styled } from "@mui/material/styles";

 const StyledOrderHistoryCard = styled("div")(
  ({ theme }) => `
    .order-history-headings {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
    .order-history-card-body-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .order-history-card-body {
      display: flex;
      flex-direction: column;
      gap: 10px;
      background-color: rgba(240, 240, 240, 0.4);
      padding: 12px;
      border-radius: 0px;
    }
    .order-history-card-body-delivery {
      display: flex;
      gap: 10px;
      align-items: center;
    }
    .delivery-icon-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: rgba(167, 141, 120, 0.1);
    }
    .delivery-icon {
      width: 14px;
    }
    .order-history-card-body-product-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .order-history-card-body-product-details {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .order-history-product-name {
      display: flex;
      gap: 20px;
      align-items: center;
    }
    .order-history-card-body-product-details-size {
      margin-top: 10px;
      display: flex;
      gap: 10px;
      align-items: center;
    }
    .order-history-size {
      display: flex;
      justify-content: center;
      align-items: center;
      width: fit-content;
      padding: 3px 10px;
      height: 20px;
      border-radius: 20px;
      background-color: #F0F0F0;
      font-family: Lexend;
      font-weight: 400;
      font-size: 12px;
      line-height: 100%;
      color: #7D634F;
    }
    .order-history-card-body-product-name {
      font-family: Lexend;
      font-weight: 400;
      font-size: 12px;
      line-height: 100%;
      color: ${theme.palette.primary.secondary};
    }
    .order-product-view-details-wrap {
      margin-top: 10px;
      display: flex;
      justify-content: flex-end;
    }
    .order-product-view-details {
      font-family: Lexend;
      font-weight: 400;
      font-size: 12px;
      line-height: 100%;
      color: ${theme.palette.primary.secondary};
      cursor: pointer;
    }
    .product-image {
      width: 56px;
      height: 64px;
      object-fit: cover;
    }
    .divider-wrap {
      margin: 10px 0px;
    }
    .nodata-container {
      margin-top: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
    } 
    .nodata-icon-box {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      background-color: #A78D7826;
    }
    .nodata-title {
      font-family: Lexend;
      font-weight: 400;
      font-size: 20px;
      color: ${theme.palette.primary.main};
      margin-bottom: 12px;
      line-height: 100%;
    }                  
    .nodata-subtitle {
      font-family: Lexend;
      font-weight: 300 !important;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      color: ${theme.palette.customColor.secondarySecond};
    }
    .nodata-button {
      font-family: Lexend;
      font-weight: 400;
      font-size: 16px;
      line-height: 100%;
      text-decoration: underline;
      color: ${theme.palette.primary.main};
      text-transform: none;
      cursor: pointer;
    }
    .order-id {
      font-family: Lexend;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      color: ${theme.palette.primary.main};
    }
    .order-items-count {
      margin: 5px 0px 10px;
      font-family: Lexend;
      font-weight: 400;
      font-size: 12px;
      line-height: 100%;
      color: ${theme.palette.customColor.secondarySecond};
    }         
    .order-date {
      font-family: Lexend;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      color: ${theme.palette.primary.main};
    }         
      .order-history-card-body-delivery-date {
        font-family: Lexend;
        font-weight: 400;
        font-size: 12px;

  `)

  export default StyledOrderHistoryCard